import { useFullPlaylist } from '../../savedItems/savedItemsQueries';
import { usePlaylistRemainingItemsAndProgress } from '../../savedItems/savedItemsHooks';
import { usePlaylistIdFromSearch } from '../hooks';
import intersectionWith from 'hs-lodash/intersectionWith';
import { useMemo } from 'react';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { H3 } from 'foundations-components/transitional/components/H3';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { List } from 'foundations-components/transitional/components/List';
import { RouterLink } from '../../../components/AcademyLinks';
import { getListingUrl } from '../../../utils/RoutingUtils';
import { LearningContentContainer } from '../../learningContent';
import FinishedContainer from '../../../components/FinishedContainer';
import { convertToLegacyLanguage } from 'academy-common-lib/constants/academySupportedLanguages';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentLink = ({
  playlistItem: {
    itemId,
    language,
    type,
    name
  }
}) => {
  const playlistId = usePlaylistIdFromSearch();
  return /*#__PURE__*/_jsx(RouterLink, {
    to: getListingUrl({
      type: type,
      id: itemId,
      isStarted: true,
      language: convertToLegacyLanguage(language),
      playlistId: playlistId || undefined,
      appearsIn: 'playlist'
    }),
    children: name
  }, `${itemId}${type.toString()}${name}`);
};
export const PlaylistIncompleteItems = ({
  navMarkerName
}) => {
  const playlistId = usePlaylistIdFromSearch();
  const {
    remainingProgressItems
  } = usePlaylistRemainingItemsAndProgress(playlistId);
  const {
    playlist,
    displayedPlaylistItems
  } = useFullPlaylist(playlistId);
  const incompleteItems = useMemo(() => {
    if (!remainingProgressItems || !displayedPlaylistItems) return [];
    return intersectionWith(displayedPlaylistItems, remainingProgressItems, (playlistItem, item) => {
      return item.itemId === playlistItem.itemId && item.type === playlistItem.type;
    });
  }, [displayedPlaylistItems, remainingProgressItems]);
  const body = playlist && /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(H3, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistContent.incompletePlaylistContent.incompleteTitle",
        options: {
          playlistTitle: playlist.name
        }
      })
    }), incompleteItems.length > 0 && /*#__PURE__*/_jsx(List, {
      wrapChildren: true,
      children: incompleteItems.map(item => /*#__PURE__*/_jsx(ContentLink, {
        playlistItem: item
      }, `${item.itemId}${item.type.toString()}${item.name}`))
    })]
  });
  const content = /*#__PURE__*/_jsx(LearningContentContainer, {
    children: /*#__PURE__*/_jsx(FinishedContainer, {
      body: body,
      illustration: /*#__PURE__*/_jsx(Illustration, {
        name: "announcement"
      })
    })
  });
  if (navMarkerName) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: navMarkerName,
      children: content
    });
  }
  return content;
};